<template>
  <!-- MODO HORIZONTAL (menú desktop) -->
  <div
    v-if="item && orientation === 'horizontal' && !forceVertical"
    class="relative flex-shrink-0"
    @mouseenter="hoverOpen = true"
    @mouseleave="hoverOpen = false"
  >
    <button
      @click="handleClick"
      class="flex items-center gap-1.5 px-2 py-1 rounded-md text-[12px] transition-colors whitespace-nowrap flex-shrink-0 focus:outline-none"
      :class="[
        isAnyActive(rutasSubarbol)
          ? 'bg-indigo-600 text-white dark:bg-indigo-600 dark:text-white font-bold shadow-sm'
          : tieneHijos
            ? 'text-gray-900 dark:text-white font-bold hover:bg-indigo-50 dark:hover:bg-gray-700'
            : 'text-gray-700 dark:text-gray-200 font-medium hover:bg-gray-100 dark:hover:bg-gray-700'
      ]"
    >
      <Icon
        :icon="item.icono || 'mdi:folder'"
        width="15"
        height="15"
        :class="tieneHijos ? 'text-indigo-600 dark:text-indigo-400' : 'text-gray-500 dark:text-gray-400'"
      />
      <span>{{ item.nombre }}</span>
      <Icon
        v-if="tieneHijos"
        :icon="hoverOpen ? 'mdi:chevron-up' : 'mdi:chevron-down'"
        width="13"
        height="13"
        class="text-indigo-600 dark:text-indigo-400 flex-shrink-0"
      />
    </button>

    <transition
      enter-active-class="transition duration-150 ease-out"
      enter-from-class="opacity-0 -translate-y-1"
      enter-to-class="opacity-100 translate-y-0"
      leave-active-class="transition duration-100 ease-in"
      leave-from-class="opacity-100 translate-y-0"
      leave-to-class="opacity-0 -translate-y-1"
    >
      <div
        v-if="tieneHijos && hoverOpen"
        class="absolute top-full left-0 mt-1 min-w-[220px] bg-white dark:bg-gray-900 rounded-xl shadow-2xl border-2 border-indigo-200 dark:border-indigo-500/50 py-1.5 z-[300]"
      >
        <SubMenuNode
          v-for="hijo in item.hijos"
          :key="hijo.id"
          :item="hijo"
          :nivel="1"
        />
      </div>
    </transition>
  </div>

  <!-- MODO VERTICAL (drawer móvil) -->
  <template v-else-if="item">
    <CollapsibleSection
      v-if="tieneHijos"
      :title="item.nombre"
      :icon="item.icono || 'mdi:folder'"
      :sidebar-collapsed="false"
      :initial-open="debeAbrirInicial"
      :name="`section-L${level}-${item.id}`"
      :active-section="activeSection"
      :level="level"
      @section-opened="$emit('section-opened', $event)"
    >
      <MenuNode
        v-for="hijo in item.hijos"
        :key="hijo.id"
        :item="hijo"
        :collapsed="false"
        :level="level + 1"
        :active-section="activeSection"
        orientation="vertical"
        @item-click="$emit('item-click', $event)"
        @section-opened="$emit('section-opened', $event)"
      />
    </CollapsibleSection>

    <MenuItem
      v-else
      :to="item.ruta || '#'"
      :icon="item.icono || 'mdi:circle-small'"
      :title="item.nombre"
      :collapsed="false"
      :is-active="isActive(item.ruta)"
      :level="level"
      @click="$emit('item-click', item)"
      class="mb-1"
    />
  </template>
</template>

<script>
import { Icon } from '@iconify/vue';
import MenuItem from './MenuItem.vue';
import CollapsibleSection from './CollapsibleSection.vue';
import SubMenuNode from './SubMenuNode.vue';

export default {
  name: 'MenuNode',
  components: { Icon, MenuItem, CollapsibleSection, SubMenuNode },
  emits: ['item-click', 'section-opened'],
  props: {
    item:          { type: Object,  required: false, default: null },
    collapsed:     { type: Boolean, default: false },
    level:         { type: Number,  default: 0 },
    activeSection: { type: String,  default: null },
    orientation:   { type: String,  default: 'vertical' },
    forceVertical: { type: Boolean, default: false }
  },
  data() {
    return { hoverOpen: false };
  },
  computed: {
    tieneHijos() {
      return Array.isArray(this.item?.hijos) && this.item.hijos.length > 0;
    },
    rutasSubarbol() {
      if (!this.item) return [];
      const rutas = [];
      const stack = [this.item];
      while (stack.length) {
        const actual = stack.pop();
        if (!actual) continue;
        if (actual.ruta) rutas.push(actual.ruta);
        if (Array.isArray(actual.hijos)) stack.push(...actual.hijos);
      }
      return rutas;
    },
    debeAbrirInicial() {
      if (!this.item) return false;
      return this.isAnyActive(this.rutasSubarbol);
    }
  },
  methods: {
    isActive(route) {
      if (!route) return false;
      return this.$route.path === route;
    },
    isAnyActive(routes) {
      if (!Array.isArray(routes)) return false;
      return routes.some(r => r && (this.$route.path === r || this.$route.path.startsWith(r + '/')));
    },
    handleClick() {
      if (!this.item) return;
      if (!this.tieneHijos && this.item.ruta) {
        this.$emit('item-click', this.item);
        this.$router.push(this.item.ruta).catch(() => {});
      }
    }
  }
};
</script>
